<template>
    <div class="mobile-footer">
        <div class="footer-links">
            <span @click="showModel(1)">会员须知</span>
            <span @click="goNews(1)">市场动态</span>
            <span @click="goNews(2)">通知公告</span>
            <span @click="showModel(2)">关于我们</span>
        </div>
        <div class="copyright">
            © Copyrights {{ Year }} {{ systemInfo.copyright ? systemInfo.copyright.web_name : '' }} All rights Reserved.
        </div>
        <div class="beian">
            <a :href="'https://beian.miit.gov.cn/'" target="_blank">
                {{ systemInfo.copyright ? systemInfo.copyright.web_site_icp : '' }}
            </a>
        </div>
        <div class="beian">
            <a :href="'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=' + recordNumber()" target="_blank">
                <img src="@/static/imgs/jinggongwanganbei.png" alt="">
                {{ systemInfo.copyright ? systemInfo.copyright.web_site_ga_icp : '' }}
            </a>
        </div>
        <div class="organizer">
            版权所有：{{ systemInfo.copyright ? systemInfo.copyright.operating_entity : '' }}
        </div>
        <div class="organizer">
            技术支持：<a :href="systemInfo.copyright ? systemInfo.copyright.technical_support_url : ''" target="_blank">
                {{ systemInfo.copyright ? systemInfo.copyright.technical_support : '' }}
            </a>
        </div>

        <!-- 弹窗 -->
        <el-dialog 
            :visible.sync="showModal" 
            width="90%"
            :close-on-click-modal="false"
            append-to-body
        >
            <div class="modal-header">
                <i :class="modeltype == 1 ? 'el-icon-user-solid' : 'el-icon-connection'"></i>
                <span>{{ modeltype == 1 ? '会员须知' : '关于我们' }}</span>
            </div>
            <div class="modal-content" v-html="modeltype == 1 ? systemInfo.system_info ? systemInfo.system_info.buy_info : '' : systemInfo.system_info ? systemInfo.system_info.about_us : ''"></div>
        </el-dialog>
    </div>
</template>

<script>
import { Session } from '@/utils/storage';

export default {
    name: 'FooterMobile',
    data() {
        return {
            systemInfo: {},
            Year: '',
            showModal: false,
            modeltype: 1
        };
    },
    mounted() {
        this.systemInfo = Session.get('systemConfig') || {};
        this.Year = new Date().getFullYear();
    },
    methods: {
        recordNumber() {
            return this.systemInfo.copyright ? (this.systemInfo.copyright.web_site_ga_icp.match(/\d/g)?.join('') || '') : '';
        },
        showModel(type) {
            this.modeltype = type;
            this.showModal = true;
        },
        goNews(type) {
            this.$router.push('/mobile/news?type=' + type).catch(() => {});
        }
    }
};
</script>

<style scoped>
.mobile-footer {
    background: #f5f5f5;
    padding: 20px 15px;
    text-align: center;
    font-size: 12px;
    color: #999;
    border-top: 1px solid #eee;
}
.footer-links {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0;
    margin-bottom: 15px;
}
.footer-links span {
    text-align: center;
    padding: 10px 0;
    color: #555;
    font-size: 13px;
    border-bottom: 1px solid #eee;
    cursor: pointer;
}
.footer-links span:nth-child(odd) {
    border-right: 1px solid #eee;
}
.footer-links span:nth-child(n+3) {
    border-bottom: none;
}
.footer-links span:active {
    color: #1890ff;
}
.copyright {
    margin: 8px 0;
}
.beian {
    margin: 5px 0;
}
.beian a {
    color: #999;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
}
.beian img {
    width: 14px;
    height: 14px;
    margin-right: 4px;
}
.organizer {
    margin: 5px 0;
    font-size: 11px;
}
.organizer a {
    color: #999;
    text-decoration: none;
}
.modal-header {
    text-align: center;
    margin-bottom: 15px;
    font-size: 18px;
    font-weight: 600;
}
.modal-header i {
    font-size: 22px;
    color: #1890ff;
    margin-right: 8px;
}
.modal-content {
    max-height: 400px;
    overflow-y: auto;
    padding: 10px;
    font-size: 14px;
    line-height: 1.8;
    text-align: left;
}
</style>
